import {
  createPlugin,
  createRoutableExtension,
  createApiFactory,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { createSearchResultListItemExtension } from '@backstage/plugin-search-react';

import { rootRouteRef } from './routes';
import { newsApiRef, NewsApiClient } from './api';

export const newsPlugin = createPlugin({
  id: 'news',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: newsApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) => new NewsApiClient({ discoveryApi, fetchApi }),
    }),
  ],
});

export const NewsPage = newsPlugin.provide(
  createRoutableExtension({
    name: 'NewsPage',
    component: () => import('./components/Router').then(m => m.Router),
    mountPoint: rootRouteRef,
  }),
);

export const AdminPage = newsPlugin.provide(
  createRoutableExtension({
    name: 'AdminPage',
    component: () => import('./components/NewsPage/AdminPage').then(m => m.AdminPage),
    mountPoint: rootRouteRef,
  }),
);

export const NewsSearchResultListItem = newsPlugin.provide(
  createSearchResultListItemExtension({
    name: 'NewsSearchResultListItem',
    component: () =>
      import('./components/NewsSearchResultListItem/NewsSearchResultListItem').then(
        m => m.NewsSearchResultListItemComponent,
      ),
    predicate: result => result.type === 'news-article',
  }),
);
